<template>
  <v-dialog
      v-model="dialog"
      max-width="900"
      style="overflow: hidden !important"
  >
    <v-card>
      <v-card-title>
        {{ processType === 'new' ? 'Stok Kategorisi Ekle' : 'Stok Kategori Düzenle' }}
        <v-spacer></v-spacer>
        <v-btn @click="closeDialog()" color="danger darken-1" style="color: white;">
          KAPAT
        </v-btn>
      </v-card-title>
      <v-card-text>
        <div class="container">
          <div class="row">
            <div class="col-lg-6">
              <v-text-field
                  solo
                  filled
                  dense
                  v-model="stockCategory.name"
                  label="Kategori Adı"
                  :error-messages="
                  validationMessages($v.stockCategory.name, 'Kategori Adı')
                "
                  prepend-inner-icon="mdi-page-layout-header"
                  @input="$v.stockCategory.name.$touch()"
                  @blur="$v.stockCategory.name.$touch()"
              ></v-text-field>
            </div>
            <div class="col-lg-6">
              <v-select
                  solo
                  filled
                  dense
                  v-model="stockCategory.groupType"
                  label="Grup Kodu"
                  :items="[
                      {value: 1, text: 'Grup Kodu'},
                      {value: 2, text: 'KOD 1'},
                      {value: 3, text: 'KOD 2'},
                      {value: 4, text: 'KOD 3'},
                      {value: 5, text: 'KOD 4'},
                      {value: 6, text: 'KOD 5'}
                    ]"
                  item-value="value"
                  item-text="text"
                  :error-messages="
                  validationMessages($v.stockCategory.groupType, 'Grup Kodu')
                "
                  prepend-inner-icon="mdi-format-list-bulleted"
                  @input="$v.stockCategory.groupType.$touch()"
                  @blur="$v.stockCategory.groupType.$touch()"
                  @change="_fetchStockCodes"
              ></v-select>
            </div>
            <div class="col-lg-6">
              <v-select
                  solo
                  filled
                  dense
                  v-model="stockCategory.groupValue"
                  label="Grup Değeri"
                  :items="groupValueList"
                  item-text="name"
                  item-value="code"
                  :error-messages="
                  validationMessages($v.stockCategory.groupValue, 'Grup Değeri')
                "
                  prepend-inner-icon="mdi-format-list-numbered"
                  @input="$v.stockCategory.groupValue.$touch()"
                  @blur="$v.stockCategory.groupValue.$touch()"
              ></v-select>
            </div>
            <div class="col-lg-6">
              <v-select
                  solo
                  filled
                  dense
                  v-model="stockCategory.baseId"
                  label="Üst Kategori"
                  :items="stockCategoryList"
                  item-text="name"
                  item-value="id"
                  prepend-inner-icon="mdi-filter-variant"
                  clearable
              ></v-select>
            </div>
            <div class="col-lg-6">
              <v-switch
                  v-model="stockCategory.isActive"
                  inset
                  :label="
                  stockCategory.isActive
                    ? 'Durum : ' + 'Aktif'
                    : 'Durum : ' + 'Pasif'
                "
              ></v-switch>
            </div>
            <div class="col-lg-6 text-center mt-3" v-if="this.stockCategory.baseId && this.processType === 'edit'">
              <v-btn
                  color="primary"
                  outlined
                  @click="_fetchSingleStockCategory(this.stockCategory.baseId)"
              >Üst Kategoriye Git
              </v-btn>
            </div>
            <div class="col-lg-12" v-if="this.processType === 'edit'">
              <h5>Alt Kategoriler</h5>
              <b-table
                  :items="stockCategory.subCategories"
                  :fields="stockCategoryListHeaders"
                  hover
                  responsive
                  sort-icon-left
                  head-row-variant="info"
                  table-variant="white"
              >
                <template #empty="scope">
                  <h6 class="text-center my-5">
                    {{ scope.loading ? "Lütfen Bekleyin" : errorMessageAll ? errorMessageAll : "Veri Bulunamadı"}}
                  </h6>
                </template>
                <template #table-busy>
                  <div class="text-center">
                    <b-spinner
                        variant="primary"
                        size="lg"
                        label="Lütfen Bekleyin..."
                    ></b-spinner>
                  </div>
                </template>
                <template #cell(isActive)="data">
                  <v-chip small label :color="data.item.isActive ? 'success ligthen-2' : 'secondary ligthen-2'">
                    {{ data.item.isActive ? 'Aktif' : 'Pasif' }}
                  </v-chip>
                </template>
                <template #cell(process)="data">
                  <div class="text-center">
                    <v-tooltip top>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                            v-bind="attrs"
                            v-on="on"
                            icon
                            color="amber darken-2"
                            @click="reassignStockCategory(data.item)"
                        >
                          <v-icon>mdi-pencil-outline</v-icon>
                        </v-btn>
                      </template>
                      <span>Düzenle</span>
                    </v-tooltip>
                    <v-tooltip top>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn v-bind="attrs" v-on="on" icon color="danger darken-2" @click="_stockCategoryDelete(data.item.id)">
                          <v-icon>mdi-delete-outline</v-icon>
                        </v-btn>
                      </template>
                      <span>Sil</span>
                    </v-tooltip>
                  </div>
                </template>
              </b-table>
            </div>
          </div>
        </div>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text color="secondary" @click="closeDialog()">İptal</v-btn>
        <v-btn text color="success" @click="_stockCategoryAdd">Kaydet</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import {required} from "vuelidate/lib/validators";
import {validationMixin} from "vuelidate";
import {validationMessages} from "@/validationMessages.js";
import {mapActions, mapState} from "vuex";
import {showProcessErrorMessage} from "@/state/alertHelpers";
//import simplebar from "simplebar-vue";


export default {
  mixins: [validationMixin],

  validations() {
    //const self = this;
    return {
      stockCategory: {
        name: {required},
        groupType: {required},
        groupValue: {required},
      }
    };
  },

  components: {
    //  simplebar
  },

  props: {
    showDialog: {
      type: Boolean,
      default: false,
    },
    stockCategoryProp: {
      type: Object,
      default: () => ({
        id: null,
        name: "",
        groupType: "",
        groupValue: "",
        top_category: "",
        isActive: true,
      }),
    },
    processType: {
      type: String,
      default: "new",
    },
  },
  computed: {
    ...mapState("dashboard", ["errorMessageAll"]),
    ...mapState("stock", ["stockCategoryList"]),
    ...mapState("auth", ["user"]),
    ...mapState("stock", ["stockCategoryListHeaders"])
  },
  data() {
    return {
      dialog: false,
      showPassword: false,
      roleGroupList: ["Yönetici", "Plasiyer", "Müşteri"],
      stockCategory: {
        name: null,
        groupType: null,
        groupValue: null,
        baseId: null,
        isActive: true,
      },
      groupValueList: []
    };
  },
  methods: {
    ...mapActions("stock", ["fetchStockCategoryList", "stockCategoryAdd", "fetchSingleStockCategory", "stockCategoryUpdate", "stockCategoryDelete"]),
    ...mapActions("stock", ["fetchStockCodes"]),
    async _stockCategoryDelete(id) {
      await this.stockCategoryDelete({
        params: {},
        body: {},
        urlSegments: [id]
      }).then(() => {
        this._fetchSingleStockCategory(this.stockCategory.id)
      })
    },
    async _stockCategoryAdd() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        if (this.processType === 'new') {
          await this.stockCategoryAdd({
            params: {
              userId: this.user.UserId
            },
            body: {
              "BaseId": this.stockCategory.baseId,
              "Name": this.stockCategory.name,
              "GroupType": this.stockCategory.groupType,
              "GroupValue": this.stockCategory.groupValue,
              "isActive": this.stockCategory.isActive
            }
          });
        } else {
          await this.stockCategoryUpdate({
            params: {
              userId: this.user.UserId
            },
            body: {
              "Id": this.stockCategory.id,
              "BaseId": this.stockCategory.baseId,
              "Name": this.stockCategory.name,
              "GroupType": this.stockCategory.groupType,
              "GroupValue": this.stockCategory.groupValue,
              "isActive": this.stockCategory.isActive
            }
          });
        }
        await this._fetchStockCategoryList();
        this.dialog = false;

      } else {
        showProcessErrorMessage({
          title: 'İşlem Başarısız',
          text: 'Lütfen gerekli alanları doldurun'
        })
      }

    },
    async _fetchSingleStockCategory(id) {
      let result = await this.fetchSingleStockCategory({
        params: {},
        body: {},
        urlSegments: [id]
      });
      this.reassignStockCategory(result);
    },
    async _fetchStockCodes() {
      this.groupValueList = await this.fetchStockCodes({
        params: {
          tableType: this.stockCategory.groupType
        },
        body: {}
      });
    },
    async _fetchStockCategoryList() {
      await this.fetchStockCategoryList({
        params: {},
        body: {},
        saltData: false
      });
    },
    validationMessages,
    closeDialog() {
      this.dialog = false;
      this.$v.$reset();
    },
    saveForm() {


    },
    reassignStockCategory(data) {
      this.stockCategory = Object.assign({}, data);
    },
    _getStockCategorySingle() {

    }

  },
  watch: {
    dialog: function (newVal) {
      this.$emit("dialogChange", newVal);
      if (!newVal)
        this.stockCategory = {
          name: null,
          groupType: null,
          groupValue: null,
          baseId: null,
          isActive: true,
        }
    },
    showDialog: function (newVal) {
      this.dialog = newVal;
    },
    stockCategoryProp: function (newVal) {
      this.stockCategory = newVal;
      this._fetchStockCodes();
    },
  },
};
</script>
